import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleArchiveLead } from "../../../../api/leads";

export default function ArchiveLead({
  isVisible,
  setVisible,
  lead,
  lead_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleArchiveLead,
    onSuccess: () => {
      message.success("Archived Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["leads", lead_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const data = { remark: "" };
    await mutate({ lead_id, data });
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [lead, form]);

  return (
    <Modal
      open={isVisible}
      title="Archive Lead"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="archiveLead"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Archive
        </Button>,
      ]}
    >
      <Form
        id="archiveLead"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Archive</span>
            this lead titled
          </div>
          <div className="font-bold text-lg">{lead?.title}?</div>
        </div>
      </Form>
    </Modal>
  );
}
